import {createActions} from 'client/framework';

const normalActions = [
  'INITIALIZE_STORE',
  'MODIFY_ACTIVE_SUPPLEMENT',
  'RESET_STORE',
  'SET_ACTIVE_SUBJECT',
  'SET_ACTIVE_SUPPLEMENT',
  'UPLOAD_FILE',
  'VALIDATE_SUPPLEMENT'
];

export default createActions(null, normalActions);
